import { render, staticRenderFns } from "./Remind.vue?vue&type=template&id=0f7f4880&scoped=true&"
import script from "./Remind.vue?vue&type=script&lang=js&"
export * from "./Remind.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7f4880",
  null
  
)

export default component.exports